import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENT_AUTHORIZATION_RESULT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'PAYMENT_AUTHORIZATION_RESULT')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      method: 'POST',
      requestAction: PAYMENT_AUTHORIZATION_RESULT.INIT_REQUEST,
      successAction: PAYMENT_AUTHORIZATION_RESULT.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENT_AUTHORIZATION_RESULT.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENT_AUTHORIZATION_RESULT.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentAuthorizationResult',
    reducerMap: {
      paymentAuthorizationResultState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
